"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidExternalColumn = exports.isValidEnhancedDropdown = void 0;
const isValidEnhancedDropdown = (link) => {
    const enhancedDropdown = link.enhancedDropdown || {};
    if (enhancedDropdown === null || enhancedDropdown === void 0 ? void 0 : enhancedDropdown.mainLinksNode) {
        return true;
    }
    const enhancedDropdownInvalid = Object.keys(enhancedDropdown).length < 1;
    if (enhancedDropdownInvalid)
        return false;
    const describeColumn = enhancedDropdown.describeColumn || {};
    delete describeColumn._type;
    const externalColumn = enhancedDropdown.externalColumn || {};
    delete externalColumn._type;
    let describeColumnValid = Object.keys(describeColumn).length > 0;
    let externalColumnValid = Object.keys(externalColumn).length > 0;
    if (externalColumnValid && Object.keys(externalColumn).length === 1 && externalColumn.links && externalColumn.links.length === 0) {
        externalColumnValid = false;
    }
    let allDescribeColumnKeysEmpty = true;
    for (const key in describeColumn) {
        if (Object.prototype.hasOwnProperty.call(describeColumn, key)) {
            const value = describeColumn[key];
            if ((typeof value === 'string' && value) || (Array.isArray(value) && value.length)) {
                allDescribeColumnKeysEmpty = false;
                break;
            }
        }
    }
    if (allDescribeColumnKeysEmpty) {
        describeColumnValid = false;
    }
    let allExternalColumnKeysEmpty = true;
    for (const key in describeColumn) {
        if (Object.prototype.hasOwnProperty.call(describeColumn, key)) {
            const value = describeColumn[key];
            if ((typeof value === 'string' && value) || (Array.isArray(value) && value.length)) {
                allExternalColumnKeysEmpty = false;
                break;
            }
        }
    }
    if (allExternalColumnKeysEmpty) {
        externalColumnValid = false;
    }
    return describeColumnValid || externalColumnValid;
};
exports.isValidEnhancedDropdown = isValidEnhancedDropdown;
const isValidExternalColumn = (externalColumn = {}) => {
    delete externalColumn._type;
    const externalColumnValid = Boolean(externalColumn && Object.keys(externalColumn).length > 0 && externalColumn.links && externalColumn.links.length > 0);
    if (externalColumn === null || externalColumn === void 0 ? void 0 : externalColumn.externalColumnNode) {
        return true;
    }
    return externalColumnValid;
};
exports.isValidExternalColumn = isValidExternalColumn;
//# sourceMappingURL=enhancedDropdownUtils.js.map